import { render, staticRenderFns } from "./ButtonShowClosedTicket.vue?vue&type=template&id=85d8d9a2&"
import script from "./ButtonShowClosedTicket.vue?vue&type=script&lang=ts&"
export * from "./ButtonShowClosedTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports